import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getDishById } from '../services/api';
import './ModernMenu.css';

const DishDetailPage = () => {
  const { dishId } = useParams();
  const navigate = useNavigate();
  const [dish, setDish] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchDish = async () => {
      try {
        console.log('Fetching dish with ID:', dishId);
        console.log('Dish ID type:', typeof dishId);
        
        const response = await getDishById(dishId);
        console.log('API response:', response);
        setDish(response.data);
        setError('');
      } catch (err) {
        console.error('Error fetching dish:', err);
        setError('Failed to load dish details');
      } finally {
        setLoading(false);
      }
    };

    if (dishId) {
      fetchDish();
    }
  }, [dishId]);

  const handleBackToMenu = () => {
    navigate('/modern-menu');
  };

  if (loading) {
    return (
      <div className="modern-menu">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading dish details...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="modern-menu">
        <div className="error-container">
          <h2>Dish Not Found</h2>
          <p>{error}</p>
          <button onClick={handleBackToMenu} className="back-button">
            Back to Menu
          </button>
        </div>
      </div>
    );
  }

  if (!dish) {
    return (
      <div className="modern-menu">
        <div className="error-container">
          <h2>Dish Not Found</h2>
          <p>The requested dish could not be found.</p>
          <button onClick={handleBackToMenu} className="back-button">
            Back to Menu
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="modern-menu">
      {/* Header */}
      <header className="detail-header">
        <button onClick={handleBackToMenu} className="back-button">
          ← Back to Menu
        </button>
        <div className="header-content">
          <h1 className="restaurant-title">الحج متولي</h1>
        </div>
      </header>

      {/* Dish Detail */}
      <main className="detail-main">
        <div className="dish-detail-container">
          <div className="dish-image-large">
            <img 
              src={dish?.imageUrl || dish?.image} 
              alt={dish?.name || 'Dish image'}
              className="detail-image"
            />
            <div className="image-gradient-overlay"></div>
          </div>
          
          <div className="dish-info">
            <h1 className="dish-title-large">{dish?.name || 'Loading...'}</h1>
            <div className="dish-meta">
              <span className="dish-price-large">${(dish?.price || 0).toFixed(2)}</span>
              <span className="dish-premium">Premium Selection</span>
            </div>
            
            <div className="dish-description-full">
              <h3>Description</h3>
              <p>{dish?.description || 'No description available'}</p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default DishDetailPage;
